import React from 'react'
import css from './course_card.module.scss'
import demo from "../asset/course_bg1.svg"
function CourseCard({title,description,click=null,image}) {
  return (
    <div className={css.course_wrap} onClick={()=>{click()}}>
        <div className={css.img_wrap}>
            <img src={image||demo} alt="" />
        </div>
        <div className={css.content_wrap}>
            <h1>{title}</h1>
            <p>{description}</p>
        </div>
    </div>
  )
}

export default CourseCard